import { render } from "./TardyDetentions.vue?vue&type=template&id=6af21c16"
import script from "./TardyDetentions.vue?vue&type=script&lang=js"
export * from "./TardyDetentions.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__